<!-- 权限申请列表 -->
<template>
   <div class='page_content'>
      <subComponents ref="showSelectData"></subComponents>
      <settingJurisdictionApply ref="settingJurisdictionApply"></settingJurisdictionApply>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini">
               <el-form-item label="申请人">
                  <el-input v-model.trim="getRequestData.opmName" placeholder="名称" @keyup.enter.native="$refs['showSelectData'].openBox('opmList', 'opmId', 'opmId', getRequestData.opmName)" clearable>
                     <el-button @click="$refs['showSelectData'].openBox('opmList', 'opmId', 'opmId', getRequestData.opmName)" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
               </el-form-item>
               <el-form-item v-show="false">
                  <el-input v-model.trim="getRequestData.opmName" placeholder="名称" @keyup.enter.native="$refs['showSelectData'].openBox('opmList', 'opmId', 'opmId')" clearable>
                     <el-button @click="$refs['showSelectData'].openBox('opmList', 'opmId', 'opmId')" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="searchData">查询</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <div class="page_content_center">
         <el-table stripe :data="returnData.list" size="mini" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
            <el-table-column align="center" label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="gpmId" label="申请编号" min-width="160">
               <template slot-scope="scope">
                  <a @click="toDetail(scope.row.gpmId)">{{ scope.row.gpmId }}</a>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="opmName" label="申请人">
            </el-table-column>
            <el-table-column align="center" prop="gpmRemark" label="申请岗位名称">
            </el-table-column>
            <el-table-column align="center" prop="gpmCreatetime" label="申请时间">
               <template slot-scope="scope">
                  <div v-if="scope.row.gpmCreatetime">
                     {{ $common.getLocalTime(scope.row.gpmCreatetime) }}
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip label="状态" prop="gpmState" min-width="100">
               <template slot-scope="scope">
                  <span>
                     {{ $common.getIsGsp('[{"key":0,"value":"初始"},{"key":-1,"value":"审核退回"},{"key":1,"value":"提交审核"},{"key":2,"value":"审核通过"}]',scope.row.gpmState) }}
                  </span>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="createrName" label="创建人">
            </el-table-column>
            <el-table-column align="center" prop="remark" label="备注">
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
import data from '../../data';
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import settingJurisdictionApply from '@/components/settingJurisdictionApply.vue'
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {settingJurisdictionApply},
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         sendDataInfo: {
            "gpmId": "",
            "gpmRemark": "",
            powerDetailAdds: [],
         },
         buttonList: [],
         getRequestData: {
            opmName: '',
            opmId: '',
            ormId: '',
            page: 1,
            rows: 30,
            end: '',
            start: '',
         },
         returnData: {
            pages: 0,  // 总页数
            total: 0,  // 总条数
            pageNum: 0,  // 当前页数
            list: []
         },
         selectedDataIndex: 0,
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.opmName': {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.getRequestData.opmId = ''
            }
         },
         deep: true,
      }
   },
   //方法集合
   methods: {
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: {
                     isPenetrate,
                  }, //参数
               },
               "*"
            );
         }
      },
      getPageInfo() {
         this.getDataList()
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0:
               this.openActionBox(actionData.actionType)
               break;
            case 1:
               this.openActionBox(actionData.actionType)
               break;
            case 2:
               this.delDataAction()
               break;
            case 3:
               this.submitData()
               break;
            case 4:
               this.openActionBox(actionData.actionType)

         }
      },
      async openActionBox(cate) {
         this.sendDataInfo.gpmId = ''
         this.sendDataInfo.gpmRemark = ''
         this.sendDataInfo.powerDetailAdds = []
         if (cate == 0) {
            this.$refs["settingJurisdictionApply"].openBox('', 0);
         } else {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
               this.$message({
                  message: '请先选中要操作的数据',
                  type: 'error'
               });
               return false
            }
            const responseData = await this.$http.powerqueryDetail({ ids: [dataInfo.gpmId] })
            if (responseData.status == 200) {
               this.$refs["settingJurisdictionApply"].openBox(responseData.result.powerdetails, 1, responseData.result.gpmRemark, responseData.result.createrName, responseData.result.remark, responseData.result.gpmId, responseData.result.gpmCreater, responseData.result.templateIds);
            }
         }
      },
      showPrintPlan() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            var info = this.returnData.list[this.selectedDataIndex];
            this.$refs.printPlan.openDia(info.gpmId);
         } else {
            return;
         }
      },
      // 获取页面按钮
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 删除数据
      delDataAction() {
         if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
               message: '请先选择您要操作的数据',
               type: 'error'
            });
            return false
         }
         var dataInfo = this.returnData.list[this.selectedDataIndex]
         this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            var delData = {
               ids: [dataInfo.gpmId]
            }
            let responseData = await this.$http.delAuthorityApply(delData)
            if (responseData.status == 200) {
               this.$message({
                  type: 'success',
                  message: '删除成功!'
               });
               this.getDataList()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }

         }).catch(() => { });

      },

      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },
      // 提交审核
      async submitData() {
         if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
               message: '请先选择您要操作的数据',
               type: 'error'
            });
            return false
         }
         var dataInfo = this.returnData.list[this.selectedDataIndex]
         // this.$confirm('确定要提交审核吗？', '提示', {
         // 	confirmButtonText: '确定',
         // 	cancelButtonText: '取消',
         // 	type: 'warning'
         // }).then(async()=> {
         var delData = {
            businessKey: dataInfo.gpmId
         }
         let responseData = await this.$http.submitAuthorityApply(delData)
         if (responseData.status == 200) {
            this.$message({
               type: 'success',
               message: '操作成功!'
            });

            this.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }

         // }).catch(() => {});

      },
      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.getAuthorityApplyList(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.pages = responseData.result.pages
            this.returnData.total = responseData.result.total
            this.returnData.pageNum = responseData.result.pageNum
            this.selectedDataIndex = 0
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },



   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getDataList()
      this.getButtonList()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
</style>
